import { useTranslation } from 'react-i18next';
import { RawErrorBoundary } from './RawErrorBoundary';

export const ErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  const { t } = useTranslation('common');
  return <RawErrorBoundary t={t}>{children}</RawErrorBoundary>;
};
